import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RESET_PASSWORD_TOKEN } from 'src/app/models/auth-user.model';
import { AccountService } from 'src/app/services/account.service';


@Component({
    selector: 'app-reset-password-form',
    templateUrl: './reset-password-form.component.html'
})
export class ResetPasswordFormComponent implements OnInit {
    resetPasswordForm: FormGroup;
    loading = false;
    submitted = false;
    token: string;

    constructor(private accountService: AccountService, private router: Router, private route: ActivatedRoute) {
        this.token = this.route.snapshot.queryParamMap.get(RESET_PASSWORD_TOKEN);
    }

    ngOnInit() {
        this.resetPasswordForm = new FormGroup({
            password: new FormControl(null, Validators.required),
            confirmPassword: new FormControl(null, [Validators.required, this.confirmPasswordValidator.bind(this)]),
            token: new FormControl(this.token)
        });
    }

    get f() {
        return this.resetPasswordForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        if (this.resetPasswordForm.invalid) {
            return;
        }

        this.loading = true;
        this.accountService.executeResetPassword({...this.resetPasswordForm.value, token: this.token}).subscribe(() => {
            this.loading = false;
            this.router.navigate(['login']);
        }, error => {
          this.loading = false;
        });
    }

    confirmPasswordValidator(control: FormControl): {[s: string]: boolean} {
        if (!!this.resetPasswordForm && (control.value !== this.resetPasswordForm.value.password)) {
          return {confirmPasswordIsInvalid: true};
        }
        return null;
      }
}
